<script setup>
defineProps({ icon: { type: String, default: 'fa-inbox' }, title: { type: String, default: '' }, text: { type: String, default: '' } })
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-2 px-6 py-10 text-center">
    <i :class="['fa-solid', icon, 'text-3xl text-faint']" aria-hidden="true"></i>
    <p v-if="title" class="font-semibold">{{ title }}</p>
    <p v-if="text" class="max-w-md text-sm text-muted">{{ text }}</p>
    <slot />
  </div>
</template>
